module.exports = __webpack_public_path__ + "static/media/envelope.4fe4e551.svg";